module.exports = __webpack_public_path__ + "static/media/elife-coins-gadgets-item.a576da6d.png";